import clsx from "clsx";
import React from "react";
import { Box, BoxProps, Button, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { colorSystem } from "../../theme";
import { getTrialEndsText } from "../../utils/text";

export const PROMO_BANNER_SPACING = 6.5;

const useStyles = makeStyles((theme) => ({
  "@global": {
    "#root": {
      marginTop: theme.spacing(PROMO_BANNER_SPACING),
    },
    "#app-drawer-minimize-icon-button": {
      marginTop: theme.spacing(PROMO_BANNER_SPACING),
    },
    ".MuiDrawer-docked > div": {
      paddingTop: theme.spacing(PROMO_BANNER_SPACING),
    },

    '[data-role="messages-list-container"]': {
      top: `${theme.spacing(PROMO_BANNER_SPACING)} !important`,
    },
  },

  root: {
    backgroundColor: theme.palette.primary.main,
    height: theme.spacing(PROMO_BANNER_SPACING),
    [theme.breakpoints.up("llg")]: {
      zIndex: 1201,
    },
    zIndex: 1199,
    position: "fixed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: 0,
    left: 0,
    right: 0,
    padding: theme.spacing(2),
  },

  text: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.palette.common.white,
  },

  link: {
    color: colorSystem.primary,
  },
}));

export interface PromoBannerProps extends BoxProps {
  plan?: string;
  setVisiblePromoBanner?: (value) => void;
}

export function PromoBanner(props: PromoBannerProps) {
  const { className, setVisiblePromoBanner, plan, ...other } = props;
  const s = useStyles();

  return (
    <Box
      className={clsx(s.root, className)}
      {...other}
      onClick={() => setVisiblePromoBanner(false)}
    >
      <>
        <Typography className={s.text}>
          Upgrade to an annual subscription today and get 12 months for the
          price of 10
        </Typography>
        <a href="/coach/plan?promoyearly">
          <Button style={{ background: "white", marginLeft: "5px" }}>
            Upgrade Now
          </Button>
        </a>
      </>
    </Box>
  );
}
